import { AwaitResponse } from '@/utils/MockUtils';

export default class PremiumImpactServices {
  /**
   * Retrieves the premium adjustment prices and dates for the Premium Adjustment timeline
   * @param {string} memberNumber member number or policy number
   * @param {boolean} showPremiumPaymentAmount whether the premium payment amount is to be included in response
   * @param {string} currentDate current date in 'YYYY-MM-DD'
   * @returns
   */
  static getPremiumAdjustmentPrices(memberNumber, showPremiumPaymentAmount = false) {
    const premiumAdjustmentData = {
      prorataPrice: 100,
      policyCrn: '12345A',
      nextContributionDate: '2023-10-15', // Format "YYYY-MM-DD"
      futureContributionDate: '2023-11-15', // Format "YYYY-MM-DD"
      frequency: 'semi-annual', // Can be one of ["fortnightly", "monthly", "quarterly", "semi-annual", "annual"]
    };

    if (showPremiumPaymentAmount) {
      premiumAdjustmentData.standardPremiumPaymentAmount = 50;
    }

    return AwaitResponse(premiumAdjustmentData);
  }
}
